window.HaloStarePreview = {
  productName: 'HaloStare Motion Eyes',
  productId: '16355149611089',
  productHandle: 'cross-border-new-dynamic-led-car-headlight-3-inch-demon-eye-led-eye-light-modified-eagle-eye-light-blink-light',
  supportSchedule: 'Support is available every day. We reply within one business day.',
  instagram: 'https://www.instagram.com/halostare/',
  pricingConfirmed: true,
  currency: 'USD',
  supportEmail: 'halostaresupport@gmail.com',
  editions: {
    '33': { variantId: '62847613239377', price: 69.99, compareAt: 89.99, discountLabel: '22% OFF', label: 'One pair — 33 modes', available: true },
    '6': { variantId: '62847613173841', price: 59.99, compareAt: 79.99, discountLabel: '25% OFF', label: 'One pair — 6 modes', available: true }
  },
  maxQuantity: Number.MAX_SAFE_INTEGER
};
